import numeral from 'numeral';

export default number =>
  numeral(number)
    .format('$0,0')
    .replace(/(^[^$]+)\$$/, (match, p1) => `$${p1}`);



// WEBPACK FOOTER //
// ../pos-master/packages/pos-helper/src/toCurrency.js